import { render, staticRenderFns } from "./SuppliersTableMobile.vue?vue&type=template&id=79715ae0&scoped=true&lang=pug"
import script from "./SuppliersTableMobile.vue?vue&type=script&lang=js"
export * from "./SuppliersTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79715ae0",
  null
  
)

export default component.exports